import { createCardEvent } from '@lc/interface/card/event/factory';

export const EventMeta = [
	createCardEvent(
		40,
		0,
		`COLLECT THE METHANE PRODUCED BY COWS`,
		`RECHARGE ONE (1) BATTERY`,
		`“DON’T LOOK AT ME, IT WAS THE COW!”`
	),
	createCardEvent(
		41,
		0,
		`COLLECT THE METHANE PRODUCED BY COWS`,
		`RECHARGE ONE (1) BATTERY`,
		`DISCLAIMER: DO NOT TRY THIS AT HOME. LAST YEAR OF CARBON AND ITS CREATORS ASSUME NO RESPONSIBILITY FOR PERSONAL INJURY ACQUIRED WHILE PLAYING THIS GAME.`
	),
	createCardEvent(
		42,
		0,
		`COLLECT BODY HEAT USING “FREE-HUGS” CAMPAIGN`,
		`RECHARGE ONE (1) BATTERY`,
		`“YOU CAN LET GO NOW.”`
	),
	createCardEvent(
		43,
		1,
		`BECOME A SUPER VEGAN`,
		`DRAW THREE (3) CARDS`,
		`“QUINOA HAS FEELINGS TOO.”`
	),
	createCardEvent(
		44,
		1,
		`CORPORATION EXERCISES FREE SPEECH`,
		`DRAW THREE (3) CARDS`,
		`“MONEY TALKS.”`
	),
	createCardEvent(
		45,
		0,
		`ATTEND AN ENERGY CONVENTION FOR THE FREE T-SHIRTS`,
		`TAKE UP TO TWO (2) ENERGY FROM A NEIGHBOR’S FACTORIES OR BATTERIES AND PUT IT IN THEIR CUP`,
		`“ALL MY SHIRTS ARE DIRTY.”`,
		true
	),
	createCardEvent(
		46,
		1,
		`ACCEPT A BRIBE`,
		`DRAW THREE (3) CARDS`,
		`“DO YOU TAKE VENMO?”`
	),
	createCardEvent(
		47,
		0,
		`WIN A COMMENT SECTION DEBATE`,
		`TAKE ONE (1) ENERGY FROM ANOTHER PLAYER AND PLACE IT IN YOUR CUP.`,
		`“I CAN BENCH MY IQ.”`,
		true
	),
	createCardEvent(
		48,
		0,
		`EMINENT DOMAIN`,
		`GIVE ANOTHER PLAYER ONE (1) PR. TAKE ONE (1) CARBON FROM THAT PLAYER’S CARBON RESERVE, SPEND IT IMMEDIATELY, AND PLACE IT IN THEIR CARBON FOOTPRINT`,
		`“NEW LAW: I CAN DO WHAT I WANT.”`,
		true
	),
	createCardEvent(
		49,
		0,
		`EMINENT DOMAIN`,
		`GIVE ANOTHER PLAYER ONE (1) PR TAKE ONE (1) CARBON FROM THAT PLAYER’S CARBON RESERVE, SPEND IT IMMEDIATELY, AND PLACE IT IN THEIR CARBON FOOTPRINT`,
		`“THE HIGHWAY REALLY TIES THE ROOM TOGETHER.”`,
		true
	),
	createCardEvent(
		50,
		0,
		`CLICKBAIT ARTICLE DEMONIZES COMPETITOR`,
		`LOSE A PR TO MOVE A CARBON FROM ANY PLAYER’S CARBON RESERVE INTO ANY PLAYER’S CARBON FOOTPRINT`,
		`“17 REASONS WHY COAL IS ON THE RISE. NUMBER 13 WILL SHOCK YOU...”`,
		true,
		true
	),
	createCardEvent(
		51,
		1,
		`FAULTY INSPECTION`,
		`REDUCE A PLAYERS’S PR BY ONE (1)`,
		`“I GAVE YOU THE GRADE I WAS PAID TO GIVE YOU.”`,
		true
	),
	createCardEvent(
		52,
		1,
		`FAULTY INSPECTION`,
		`REDUCE A PLAYERS’S PR BY ONE (1)`,
		`“THESE AREN’T PLUTONIUM RODS — THEY’RE PRETZEL RODS!”`,
		true
	),
	createCardEvent(
		53,
		0,
		`ATTACH A KEY TO A KITE IN A THUNDERSTORM`,
		`RECHARGE ONE (1) BATTERY`,
		`“QUITE FRANKLIN-Y, NOT THE BEST IDEA.”`
	),
	createCardEvent(
		54,
		0,
		`MAKE TINDER FOR ENVIRONMENTAL SCIENTISTS`,
		`IF NEITHER NEIGHBOR HAS A CHARGED BATTERY, RECHARGE TWO (2) BATTERIES WITH THE COLOR ENERGY OF YOUR NEIGHBORS`,
		`“CARBON DATING.”`
	),
	createCardEvent(
		55,
		0,
		`CLICK ON A POP-UP AD`,
		`PICK A PLAYER AND LET THEM STEAL ONE (1) CARD AT RANDOM FROM YOUR HAND. IN EXCHANGE THEY MUST GIVE YOU ONE (1) ENERGY (YOU MUST HAVE AT LEAST ONE (1) CARD TO BE STOLEN)`,
		`“HOT SHINGLES IN YOUR AREA! INSTALL SOLAR ROOFING TODAY!”`,
		true
	),
	createCardEvent(
		56,
		1,
		`BATTERY DRAINED FROM USING TOO MANY APPS`,
		`MAKE ANY PLAYER LOSE A BATTERY (YOU MAY ONLY SELECT A CHARGED BATTERY IF ALL OF THAT PLAYER’S BATTERIES ARE CHARGED)`,
		`“PUT DOWN THAT NEWFANGLED DEVICE FOR ONE MINUTE.”`,
		true
	),
	createCardEvent(
		57,
		0,
		`BUILD A WIND TURBINE AND THEN A WALL IN FRONT OF YOUR NEIGHBOR’S WIND TURBINE`,
		`STEAL ONE (1) ENERGY FROM A NEIGHBOR`,
		`“THE CRAZIEST PART WAS THEY PAID FOR IT.”`,
		true
	),
];
